import { BaseService } from './_BaseService';

export class AccountService extends BaseService {
    updateProfile = async (user) => {
        return await this.post(`sales/update-profile`, user);
    }
}